// URL WebSocket сервера сигналинга. В проде — через nginx (/meetings-ws). В dev можно задать REACT_APP_MEETINGS_WS_URL=ws://localhost:5001
export function getMeetingsWsUrl() {
    if (process.env.REACT_APP_MEETINGS_WS_URL) {
        return process.env.REACT_APP_MEETINGS_WS_URL;
    }
    const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
    return `${protocol}//${window.location.host}/meetings-ws`;
}
